document.addEventListener("DOMContentLoaded", function () {
  const tiles = document.querySelectorAll(".why-tile");
  const container = document.querySelector(".why-content");

  tiles.forEach((tile) => {
    tile.addEventListener("mouseenter", () => {
      if (window.innerWidth < 768) return;
      tiles.forEach((t) => t.classList.remove("active"));
      tile.classList.add("active");
    });
  });

  let scrollHandler = () => {
    let containerCenter = container.scrollLeft + container.offsetWidth / 2;

    let closestTile = null;
    let closestDistance = Infinity;

    tiles.forEach((tile) => {
      const tileCenter = tile.offsetLeft + tile.offsetWidth / 2;
      const distance = Math.abs(containerCenter - tileCenter);
      let tileRect = tile.getBoundingClientRect();

      if (tileRect.left > 0 && !closestTile) {
        closestDistance = distance;
        closestTile = tile;
      }
    });

    tiles.forEach((tile) => tile.classList.remove("active"));

    if (closestTile) {
      closestTile.classList.add("active");
    }
  };

  let scrollHandlerAttached = false;
  let setScrollHandler = () => {
    if (window.innerWidth <= 768 && !scrollHandlerAttached) {
      container.addEventListener("scroll", scrollHandler);
      scrollHandler();
      scrollHandlerAttached = true;
    } else if (window.innerWidth > 768 && scrollHandlerAttached) {
      container.removeEventListener("scroll", scrollHandler);
      scrollHandlerAttached = false;
    }
  };

  window.addEventListener("resize", setScrollHandler);
  setScrollHandler();
});
